export const documentsMode = {
    ONGOING: 'ongoing',
    ARCHIVE: 'archive'
}

export const shareSystemsActive = (demandHeader) => {
    const arr = [];
    if (!!demandHeader?.applicationClientSettings?.sharepointIntegration?.active) {
        arr.push("sharepoint")
    }
    if (!!demandHeader?.applicationClientSettings?.ezdpuwIntegration?.active && demandHeader?.applicationClientSettings?.ezdpuwIntegration?.documentsMode === documentsMode.ONGOING) {
        arr.push("ezdpuw")
    }
    if (!!demandHeader?.applicationClientSettings?.ezdrpIntegration?.active && demandHeader?.applicationClientSettings?.ezdrpIntegration?.documentsMode === documentsMode.ONGOING) {
        arr.push("ezdrp")
    }
    return arr;
}
export const shareSystemsActiveArchive = (demandHeader) => {
    const arr = [];
    if (!!demandHeader?.applicationClientSettings?.ezdpuwIntegration?.active && demandHeader?.applicationClientSettings?.ezdpuwIntegration?.documentsMode === documentsMode.ARCHIVE) {
        arr.push("ezdpuw")
    }
    if (!!demandHeader?.applicationClientSettings?.ezdrpIntegration?.active && demandHeader?.applicationClientSettings?.ezdrpIntegration?.documentsMode === documentsMode.ARCHIVE) {
        arr.push("ezdrp")
    }
    return arr;
}

export const shareSystemsConnected = (demandHeader) => {
    const arr = [];
    if (!!(demandHeader?.applicationClientSettings?.sharepointIntegration?.connected)) {
        arr.push("sharepoint")
    }
    if (!!(demandHeader?.applicationClientSettings?.ezdpuwIntegration?.connected)) {
        arr.push("ezdpuw")
    }
    if (!!(demandHeader?.applicationClientSettings?.ezdrpIntegration?.connected)) {
        arr.push("ezdrp")
    }
    return arr;
}

export const shareSystemsConnectedArchive = (demandHeader) => {
    const arr = [];
    if (!(demandHeader?.applicationClientSettings?.ezdpuwIntegration?.connected)) {
        arr.push("ezdpuw")
    }
    if (!(demandHeader?.applicationClientSettings?.ezdrpIntegration?.connected)) {
        arr.push("ezdrp")
    }
    return arr;
}